export interface GeoMultipleEntry {
  market: string;
  state: string;
  reportedSales: number;
  revenueMultiple: number;
  cashflowMultiple: number;
}

export const CBSA_MULTIPLES: GeoMultipleEntry[] = [
  { market: "Birmingham-Hoover, AL", state: "AL", reportedSales: 18, revenueMultiple: 0.4, cashflowMultiple: 1.99 },
  { market: "Phoenix-Mesa-Scottsdale, AZ", state: "AZ", reportedSales: 292, revenueMultiple: 0.63, cashflowMultiple: 2.35 },
  { market: "Tucson, AZ", state: "AZ", reportedSales: 35, revenueMultiple: 0.78, cashflowMultiple: 2.79 },
  { market: "Contra Costa-Alameda-Solano, CA", state: "CA", reportedSales: 87, revenueMultiple: 0.66, cashflowMultiple: 2.42 },
  { market: "Fresno, CA", state: "CA", reportedSales: 24, revenueMultiple: 0.82, cashflowMultiple: 2.1 },
  { market: "Los Angeles-Long Beach-Santa Ana, CA", state: "CA", reportedSales: 481, revenueMultiple: 0.6, cashflowMultiple: 2.38 },
  { market: "Orange County, CA", state: "CA", reportedSales: 187, revenueMultiple: 0.59, cashflowMultiple: 2.36 },
  { market: "Riverside-San Bernardino-Ontario, CA", state: "CA", reportedSales: 122, revenueMultiple: 0.52, cashflowMultiple: 2.24 },
  { market: "Sacramento--Arden-Arcade--Roseville, CA", state: "CA", reportedSales: 94, revenueMultiple: 0.68, cashflowMultiple: 2.43 },
  { market: "San Diego-Carlsbad-San Marcos, CA", state: "CA", reportedSales: 124, revenueMultiple: 0.66, cashflowMultiple: 2.41 },
  { market: "San Francisco-Oakland-Fremont, CA", state: "CA", reportedSales: 153, revenueMultiple: 0.73, cashflowMultiple: 2.78 },
  { market: "San Jose-Sunnyvale-Santa Clara, CA", state: "CA", reportedSales: 71, revenueMultiple: 0.73, cashflowMultiple: 2.4 },
  { market: "Denver-Aurora, CO", state: "CO", reportedSales: 217, revenueMultiple: 0.64, cashflowMultiple: 2.68 },
  { market: "Bridgeport-Stamford-Norwalk, CT", state: "CT", reportedSales: 47, revenueMultiple: 0.58, cashflowMultiple: 2.2 },
  { market: "Hartford-West Hartford-East Hartford, CT", state: "CT", reportedSales: 40, revenueMultiple: 0.52, cashflowMultiple: 2.09 },
  { market: "New Haven-Milford, CT", state: "CT", reportedSales: 19, revenueMultiple: 0.73, cashflowMultiple: 2.54 },
  { market: "Washington-Arlington-Alexandria, DC-VA-MD-WV", state: "DC-VA-MD-WV", reportedSales: 183, revenueMultiple: 0.56, cashflowMultiple: 2.36 },
  { market: "Jacksonville, FL", state: "FL", reportedSales: 73, revenueMultiple: 0.62, cashflowMultiple: 2.29 },
  { market: "Miami-Fort Lauderdale-Miami Beach, FL", state: "FL", reportedSales: 421, revenueMultiple: 0.59, cashflowMultiple: 2.35 },
  { market: "Orlando-Kissimmee, FL", state: "FL", reportedSales: 213, revenueMultiple: 0.69, cashflowMultiple: 2.57 },
  { market: "Tampa-St. Petersburg-Clearwater, FL", state: "FL", reportedSales: 633, revenueMultiple: 0.97, cashflowMultiple: 2.99 },
  { market: "Atlanta-Sandy Springs-Marietta, GA", state: "GA", reportedSales: 305, revenueMultiple: 0.59, cashflowMultiple: 2.31 },
  { market: "Honolulu, HI", state: "HI", reportedSales: 8, revenueMultiple: 0.38, cashflowMultiple: 1.69 },
  { market: "Chicago-Naperville-Joliet, IL-IN-WI", state: "IL-IN-WI", reportedSales: 179, revenueMultiple: 0.63, cashflowMultiple: 2.43 },
  { market: "Indianapolis-Carmel, IN", state: "IN", reportedSales: 27, revenueMultiple: 0.75, cashflowMultiple: 2.55 },
  { market: "Wichita, KS", state: "KS", reportedSales: 4, revenueMultiple: 1.12, cashflowMultiple: 3.56 },
  { market: "Louisville-Jefferson County, KY-IN", state: "KY-IN", reportedSales: 24, revenueMultiple: 0.7, cashflowMultiple: 3.1 },
  { market: "New Orleans-Metairie-Kenner, LA", state: "LA", reportedSales: 19, revenueMultiple: 0.74, cashflowMultiple: 2.94 },
  { market: "Boston-Cambridge-Quincy, MA-NH", state: "MA-NH", reportedSales: 171, revenueMultiple: 0.61, cashflowMultiple: 2.38 },
  { market: "Baltimore-Towson, MD", state: "MD", reportedSales: 79, revenueMultiple: 0.59, cashflowMultiple: 2.43 },
  { market: "Detroit-Warren-Livonia, MI", state: "MI", reportedSales: 116, revenueMultiple: 0.62, cashflowMultiple: 2.98 },
  { market: "Minneapolis-St. Paul-Bloomington, MN-WI", state: "MN-WI", reportedSales: 120, revenueMultiple: 0.73, cashflowMultiple: 2.64 },
  { market: "St. Louis, MO-IL", state: "MO-IL", reportedSales: 37, revenueMultiple: 0.65, cashflowMultiple: 2.55 },
  { market: "Kansas City, MO-KS", state: "MO-KS", reportedSales: 28, revenueMultiple: 0.57, cashflowMultiple: 2.81 },
  { market: "Durham, NC", state: "NC", reportedSales: 10, revenueMultiple: 0.48, cashflowMultiple: 2.86 },
  { market: "Greensboro-High Point, NC", state: "NC", reportedSales: 16, revenueMultiple: 0.58, cashflowMultiple: 2.61 },
  { market: "Raleigh-Cary, NC", state: "NC", reportedSales: 62, revenueMultiple: 0.59, cashflowMultiple: 1.93 },
  { market: "Winston-Salem, NC", state: "NC", reportedSales: 3, revenueMultiple: 0.41, cashflowMultiple: 1.48 },
  { market: "Charlotte-Gastonia-Concord, NC-SC", state: "NC-SC", reportedSales: 85, revenueMultiple: 0.65, cashflowMultiple: 2.66 },
  { market: "New Jersey", state: "NJ", reportedSales: 206, revenueMultiple: 0.6, cashflowMultiple: 2.33 },
  { market: "Albuquerque, NM", state: "NM", reportedSales: 14, revenueMultiple: 0.71, cashflowMultiple: 3.0 },
  { market: "Las Vegas-Paradise, NV", state: "NV", reportedSales: 136, revenueMultiple: 0.63, cashflowMultiple: 2.22 },
  { market: "Albany-Schenectady-Troy, NY", state: "NY", reportedSales: 8, revenueMultiple: 0.79, cashflowMultiple: 2.74 },
  { market: "Buffalo-Niagara Falls, NY", state: "NY", reportedSales: 11, revenueMultiple: 0.68, cashflowMultiple: 2.53 },
  { market: "Rochester, NY", state: "NY", reportedSales: 17, revenueMultiple: 0.53, cashflowMultiple: 3.1 },
  { market: "New York-Northern New Jersey-Long Island, NY-NJ-PA", state: "NY-NJ-PA", reportedSales: 420, revenueMultiple: 0.64, cashflowMultiple: 2.41 },
  { market: "Cleveland-Elyria-Mentor, OH", state: "OH", reportedSales: 38, revenueMultiple: 0.81, cashflowMultiple: 3.2 },
  { market: "Columbus, OH", state: "OH", reportedSales: 40, revenueMultiple: 0.56, cashflowMultiple: 2.8 },
  { market: "Dayton, OH", state: "OH", reportedSales: 17, revenueMultiple: 0.87, cashflowMultiple: 3.43 },
  { market: "Cincinnati-Middletown, OH-KY-IN", state: "OH-KY-IN", reportedSales: 47, revenueMultiple: 0.73, cashflowMultiple: 2.74 },
  { market: "Oklahoma City, OK", state: "OK", reportedSales: 23, revenueMultiple: 0.64, cashflowMultiple: 2.84 },
  { market: "Tulsa, OK", state: "OK", reportedSales: 20, revenueMultiple: 0.64, cashflowMultiple: 2.62 },
  { market: "Portland-Vancouver-Beaverton, OR-WA", state: "OR-WA", reportedSales: 114, revenueMultiple: 0.52, cashflowMultiple: 2.64 },
  { market: "Pittsburgh, PA", state: "PA", reportedSales: 52, revenueMultiple: 0.76, cashflowMultiple: 2.97 },
  { market: "Philadelphia-Camden-Wilmington, PA-NJ-DE-MD", state: "PA-NJ-DE-MD", reportedSales: 141, revenueMultiple: 0.68, cashflowMultiple: 2.52 },
  { market: "Providence-New Bedford-Fall River, RI-MA", state: "RI-MA", reportedSales: 41, revenueMultiple: 0.6, cashflowMultiple: 2.65 },
  { market: "Nashville-Davidson--Murfreesboro, TN", state: "TN", reportedSales: 95, revenueMultiple: 0.56, cashflowMultiple: 2.18 },
  { market: "Memphis, TN-MS-AR", state: "TN-MS-AR", reportedSales: 13, revenueMultiple: 0.45, cashflowMultiple: 2.07 },
  { market: "Austin-Round Rock, TX", state: "TX", reportedSales: 86, revenueMultiple: 0.64, cashflowMultiple: 2.23 },
  { market: "Dallas-Fort Worth-Arlington, TX", state: "TX", reportedSales: 331, revenueMultiple: 0.71, cashflowMultiple: 2.51 },
  { market: "Houston-Sugar Land-Baytown, TX", state: "TX", reportedSales: 252, revenueMultiple: 0.65, cashflowMultiple: 2.41 },
  { market: "San Antonio, TX", state: "TX", reportedSales: 51, revenueMultiple: 0.76, cashflowMultiple: 2.44 },
  { market: "Salt Lake City, UT", state: "UT", reportedSales: 51, revenueMultiple: 0.9, cashflowMultiple: 2.85 },
  { market: "Richmond, VA", state: "VA", reportedSales: 44, revenueMultiple: 0.59, cashflowMultiple: 2.26 },
  { market: "Virginia Beach-Norfolk-Newport News, VA-NC", state: "VA-NC", reportedSales: 34, revenueMultiple: 0.65, cashflowMultiple: 2.88 },
  { market: "Seattle-Tacoma-Bellevue, WA", state: "WA", reportedSales: 217, revenueMultiple: 0.62, cashflowMultiple: 2.35 },
  { market: "Milwaukee-Waukesha-West Allis, WI", state: "WI", reportedSales: 35, revenueMultiple: 0.86, cashflowMultiple: 3.4 },
];

function computeWeightedAverage(
  entries: GeoMultipleEntry[],
  field: "revenueMultiple" | "cashflowMultiple",
): number {
  let weightedSum = 0;
  let totalSales = 0;
  for (const e of entries) {
    weightedSum += e[field] * e.reportedSales;
    totalSales += e.reportedSales;
  }
  return totalSales > 0 ? weightedSum / totalSales : 0;
}

export interface StateMultiple {
  state: string;
  revenueMultiple: number;
  cashflowMultiple: number;
}

function buildStateAverages(): StateMultiple[] {
  const stateGroups = new Map<string, GeoMultipleEntry[]>();

  const stateMapping: Record<string, string[]> = {
    AL: ["Birmingham-Hoover, AL"],
    AZ: ["Phoenix-Mesa-Scottsdale, AZ", "Tucson, AZ"],
    CA: [
      "Contra Costa-Alameda-Solano, CA", "Fresno, CA",
      "Los Angeles-Long Beach-Santa Ana, CA", "Orange County, CA",
      "Riverside-San Bernardino-Ontario, CA", "Sacramento--Arden-Arcade--Roseville, CA",
      "San Diego-Carlsbad-San Marcos, CA", "San Francisco-Oakland-Fremont, CA",
      "San Jose-Sunnyvale-Santa Clara, CA",
    ],
    CO: ["Denver-Aurora, CO"],
    CT: ["Bridgeport-Stamford-Norwalk, CT", "Hartford-West Hartford-East Hartford, CT", "New Haven-Milford, CT"],
    FL: ["Jacksonville, FL", "Miami-Fort Lauderdale-Miami Beach, FL", "Orlando-Kissimmee, FL", "Tampa-St. Petersburg-Clearwater, FL"],
    GA: ["Atlanta-Sandy Springs-Marietta, GA"],
    HI: ["Honolulu, HI"],
    IN: ["Indianapolis-Carmel, IN"],
    KS: ["Wichita, KS"],
    LA: ["New Orleans-Metairie-Kenner, LA"],
    MD: ["Baltimore-Towson, MD"],
    MI: ["Detroit-Warren-Livonia, MI"],
    NC: ["Durham, NC", "Greensboro-High Point, NC", "Raleigh-Cary, NC", "Winston-Salem, NC"],
    NJ: ["New Jersey"],
    NM: ["Albuquerque, NM"],
    NV: ["Las Vegas-Paradise, NV"],
    NY: ["Albany-Schenectady-Troy, NY", "Buffalo-Niagara Falls, NY", "Rochester, NY"],
    OH: ["Cleveland-Elyria-Mentor, OH", "Columbus, OH", "Dayton, OH"],
    OK: ["Oklahoma City, OK", "Tulsa, OK"],
    PA: ["Pittsburgh, PA"],
    TN: ["Nashville-Davidson--Murfreesboro, TN"],
    TX: ["Austin-Round Rock, TX", "Dallas-Fort Worth-Arlington, TX", "Houston-Sugar Land-Baytown, TX", "San Antonio, TX"],
    UT: ["Salt Lake City, UT"],
    VA: ["Richmond, VA"],
    WA: ["Seattle-Tacoma-Bellevue, WA"],
    WI: ["Milwaukee-Waukesha-West Allis, WI"],
  };

  for (const [state, markets] of Object.entries(stateMapping)) {
    const entries = CBSA_MULTIPLES.filter((e) => markets.includes(e.market));
    stateGroups.set(state, entries);
  }

  const result: StateMultiple[] = [];
  for (const state of Object.keys(stateMapping)) {
    const entries = stateGroups.get(state);
    if (entries && entries.length > 0) {
      result.push({
        state,
        revenueMultiple: computeWeightedAverage(entries, "revenueMultiple"),
        cashflowMultiple: computeWeightedAverage(entries, "cashflowMultiple"),
      });
    }
  }
  return result;
}

export const STATE_MULTIPLES: StateMultiple[] = buildStateAverages();

export const NATIONAL_AVERAGE = {
  revenueMultiple: computeWeightedAverage(CBSA_MULTIPLES, "revenueMultiple"),
  cashflowMultiple: computeWeightedAverage(CBSA_MULTIPLES, "cashflowMultiple"),
};
